import { createSelector } from "@reduxjs/toolkit";
export const submitEvidenceState = (state) => state.submitEvidenceSlice;

export const submitEvidenceSelectors = createSelector(submitEvidenceState, (state) => state);
